(function(window) {
   'use strict';

   window.TSC = window.TSC || {};
   window.TSC.statusCodes = (function() {
      return Object.freeze({
         UnprocessableEntity: 422
      });
   }());
}(this));
